module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/area-17740923a7efa980d932f07160893a2a.webp";